import {useCallback} from 'react';
import {useNavigate} from 'react-router';
import {useSelector, useDispatch} from 'react-redux';
import {useAndroidBackButton} from 'extensions/navigation/hooks/useAndroidBackButton';
import {useParams} from 'extensions/navigation';
import {FolderContents} from 'interface/stacks/FolderContents';

import * as files from 'store/slices/files';
import * as effects from 'interface/hooks/effects/files';

export default () => {
  const {folderKey} = useParams<"folderKey">();
  const parentKey = useSelector(files.selectors.getParent(folderKey));
  const isSearch = useSelector(files.selectors.isSearch);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchClose = useCallback(effects.search(navigate, dispatch, null), []);

  useAndroidBackButton(() => {
    if (isSearch) {
      searchClose();
      return true;
    } else if (folderKey === 'myfiles') {
      return false;
    } else {
      navigate(`/folder/${parentKey}`);
      return true;
    }
  });

  return (
    <FolderContents id={folderKey}/>
  );
}
